import React, { useCallback, useRef, useEffect } from 'react'
import Button from '@mui/material/Button'
import MuiDialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Input from '../forms/Input'
import { useForm } from 'react-hook-form'
import { IconButton } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { SubmitSending } from 'components'

export default function Dialog(_props) {
  const {
    title = 'Definir Activos', // 'Dialog title',
    message = null, // 'Dialog message',
    primaryButtonText = 'Definir', //Label of the primary button
    secondaryButtonText = 'Cancelar', // Label of the cancel button
    onSubmit = () => {
      console.log('provide a submit handler function')
    }, // Form submit action
    handleClose = () => {
      console.log('Provide a function to close the dialog')
    }, // Dialog close action
    open = false, // Dialog open state
    fields = [],
    children, // Array of fields to render
    hasFields = false,
  } = _props
  function mapFieldParam(param, defaultValue = '') {
    return fields.reduce((accumulator, current) => {
      accumulator[current.name] = current?.[param] || defaultValue
      return accumulator
    }, {})
  }

  const firstInputRef = useRef(null)
  const [isNumber, setIsNumber] = React.useState(hasFields)

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm()
  React.useEffect(() => {
    watch((value, { name, type }) => {
      if (name === 'nromov' && value !== null) {
        setIsNumber(false)
      }
    })
  }, [watch])
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  useEffect(() => {
    if (firstInputRef.current !== null) {
      firstInputRef.current.focus()
    }
  }, [])

  function handleSend() {
    setIsSubmitting(true)
    onSubmit()
  }
  const FormFields = useCallback(() => {
    if (fields.length === 0) return null
    return (
      <form id="dialog-form" onSubmit={handleSubmit(onSubmit)} noValidate>
        {fields.map((field, index) => {
          const { name, label = null, validation = {}, ...rest } = field
          return (
            <Input
              ref={index === 0 ? firstInputRef : null}
              autoFocus={index === 0}
              key={name}
              control={control}
              name={name}
              label={label || null}
              validation={validation || null}
              errors={errors?.[name] || null}
              type={field?.type || 'text'}
              {...rest}
            />
          )
        })}
      </form>
    )
  }, [fields, onSubmit, control, handleSubmit, errors])
  const primaryActionButtonProps = useCallback(() => {
    return fields.length === 0
      ? { onClick: onSubmit }
      : { type: 'submit', form: 'dialog-form' }
  }, [onSubmit, fields.length])

  return (
    <MuiDialog
      open={open}
      onClose={handleClose}
      disableAutoFocus={true}
      maxWidth="lg"
    >
      <DialogTitle
        variant="h1"
        color="primary"
        className="pt-6 md:whitespace-nowrap"
      >
        {title}
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        color="primary"
        className="absolute right-1 top-2"
      >
        <FontAwesomeIcon icon={faXmark} fixedWidth />
      </IconButton>
      <DialogContent>
        <DialogContentText
          variant="body1"
          gutterBottom
          className="whitespace-pre-line"
        >
          {message}
        </DialogContentText>
        <div className="py-6 w-4/5 mx-auto flex flex-col justify-start items-center">
          <FormFields fields={fields} />
          {children}
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          {secondaryButtonText}
        </Button>
        <Button
          disabled={isNumber}
          variant="contained"
          type="submit"
          form="dialog-form"
          {...primaryActionButtonProps}
          onClick={fields.length === 0 ? handleSend : null}
        >
          {(isSubmitting && <SubmitSending label="Validando" />) ||
            primaryButtonText}
        </Button>
      </DialogActions>
    </MuiDialog>
  )
}
